@if (hasData()) {
  <sk-checkbox
    stylingMode="unformed"
    data-test="dms-grid-checkbox-template"
    clickStopPropagation
    [(ngModel)]="checked"
    (ngModelChange)="checkboxChange($event)"
  ></sk-checkbox>
}
